import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Compass, Languages } from "lucide-react";
import { useTour } from "@/context/TourContext";

// Global, always-visible controls (top-right on every module/section):
//  - Language toggle for the guided tour / help content (EN / ES)
//  - Start the interactive guided tour for the current page
export default function HeaderControls() {
  const tour = useTour();
  const loc = useLocation();
  useEffect(() => {
    if (!tour?.autoStartForRoute) return;
    const t = setTimeout(() => tour.autoStartForRoute(loc.pathname), 700);
    return () => clearTimeout(t);
  }, [loc.pathname, tour]);
  if (!tour) return null;
  const { startTourForRoute, lang, toggleLang } = tour;
  const en = lang === "en";
  return (
    <div data-testid="header-controls" className="fixed top-3 left-1/2 -translate-x-1/2 z-40 flex items-center gap-2 print:hidden">
      <button
        data-testid="global-lang-toggle"
        onClick={toggleLang}
        title={en ? "Guide / help language: English — click for Spanish" : "Idioma de la guía / ayuda: Español — clic para Inglés"}
        className="flex items-center gap-1.5 rounded-full border border-slate-200 bg-white/90 backdrop-blur px-3 py-1.5 text-xs font-bold text-slate-700 shadow-sm hover:border-[#2495D3] hover:text-[#2495D3] transition-colors"
      >
        <Languages size={14} /> {en ? "EN" : "ES"}
      </button>
      <button
        data-testid="global-tour-button"
        onClick={() => startTourForRoute(loc.pathname)}
        title={en ? "Start an interactive guided tour of this page" : "Inicia un recorrido guiado interactivo de esta página"}
        className="flex items-center gap-1.5 rounded-full bg-[#2495D3] px-3.5 py-1.5 text-xs font-bold text-white shadow-sm hover:bg-[#1E7AA9] transition-colors"
      >
        <Compass size={14} /> {en ? "Guide" : "Guía"}
      </button>
    </div>
  );
}
